import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHydroquinoneGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.74 23.44a.748.748 0 0 0-1.06.08l-5.86 6.75c-1.11-2.13-4.15-6.61-10.08-6.97V8.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v14.5H9.5V8.75a.749.749 0 1 0-1.5 0v30.5c0 .41.34.75.75.75s.75-.34.75-.75v-14.5h11.74v14.5c0 .41.34.75.75.75s.75-.34.75-.75V24.79c5.81.4 8.38 5.24 9.02 6.69l-6.32 7.28c-.27.31-.24.79.07 1.06.14.12.32.18.49.18.21 0 .42-.09.57-.26l13.24-15.25c.28-.31.24-.78-.07-1.05Z",
    fill: "currentColor"
  }));
}

export { SvgHydroquinoneGlyphSecondary as default };
